import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import FirebaseStore from 'stores/FirebaseStore';
import ProfileStore from 'stores/ProfileStore';
import { SECOND_AS_MILLISECONDS } from 'enum/timeFormat';
import { BROADCAST_STATUS, INITIAL_DISCONNECT_TIMER_SECONDS } from 'enum/videoPlayer';
import { SecondsTimer } from 'utils/timers';

import DMCABadge from '../../../images/DMCABadge.png';

import styles from './DesktopBroadcastReconnect.css';


const secondsTimer = new SecondsTimer();

function DesktopBroadcastReconnect() {
  const [secondsCounter, setSecondsCounter] = useState(null);

  function disconnect() {
    const { setBroadcastStatus } = ProfileStore;
    setBroadcastStatus(BROADCAST_STATUS.DISCONNECTED);
  }

  const updateTimer = useCallback((secondsToReconnect) => {
    setSecondsCounter(secondsToReconnect);

    if (secondsToReconnect < 0) {
      secondsTimer.stop();
      disconnect();
    }
  }, []);

  const handleCountDown = useCallback(() => {
    const { serverOffset, disconnectTimestamp } = FirebaseStore;
    const nowMillis = new Date().getTime() + serverOffset;
    const millisSinceDisconnect = nowMillis - disconnectTimestamp;
    const secondsToReconnect = INITIAL_DISCONNECT_TIMER_SECONDS - (millisSinceDisconnect / SECOND_AS_MILLISECONDS);
    const reconnectInterval = secondsToReconnect + 1;

    secondsTimer.start(updateTimer, reconnectInterval);
  }, [updateTimer]);

  useEffect(() => {
    handleCountDown();

    return () => {
      secondsTimer.stop();
    };
  }, [handleCountDown]);

  let parsedSeconds = moment.utc(secondsCounter * SECOND_AS_MILLISECONDS).format('mm:ss');
  if (parsedSeconds === '00:00') {
    parsedSeconds = '';
  }

  return (
    <div className={styles.desktopBroadcastReconnect}>
      <div className={styles.DMCABadgeWrapper}>
        <img
          alt="DMCABadge"
          className={styles.DMCABadge}
          src={DMCABadge}
        />
      </div>
      <h3 className={styles.reconnectText}>
        {`${translate('v2profile.broadcast.reconnect')} ${parsedSeconds}`}
      </h3>
    </div>
  );
}

export default observer(DesktopBroadcastReconnect);
